export default __webpack_public_path__ + "static/media/checkLogo.dc71013e.svg";